import { toast } from 'sonner';

/** Copies text to the clipboard and reports the outcome with a toast. */
export async function copyText(value: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(value);
    toast.success('Copied');
  } catch {
    toast.error('Could not copy to clipboard');
  }
}
